import { render, staticRenderFns } from "./RelatorioCargaDescargaListFiltroModalItemInputTerminal.vue?vue&type=template&id=535ce447"
import script from "./RelatorioCargaDescargaListFiltroModalItemInputTerminal.vue?vue&type=script&lang=js"
export * from "./RelatorioCargaDescargaListFiltroModalItemInputTerminal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports